import React, { useEffect, useState } from "react";
import Dropdown from "../../../../components/common/dropdown";
import Button from "../../../../components/common/button";
import { EditOutlined, KeyOutlined, StarOutlined } from "@ant-design/icons";
import { Link, useParams } from "react-router-dom";
import {
  Form,
  Input as InputField,
  message,
  Card,
  Typography,
  Space,
  Skeleton,
} from "antd";
import colors from "../../../../share/constants/constants";
import Back from "./../../../../assets/icons/LeftBack.svg";

import { getCustomersDetils, updateCustomer } from "../../../../api/customer";
import { UsaStates } from "usa-states";
import EarnedPointsModal from "../../../../components/common/earnedPointsModal";
import PasswordResetModal from "./passwordResetModal";
var usStates = new UsaStates();
const Personalsettings = (props) => {
  let { id } = useParams();

  const [form] = Form.useForm();
  const [data, setData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [inProgress, setInProgress] = useState(false);
  const [earnPointsModal, setEarnPointsModal] = useState(false);
  const [passwordModal, setPasswordModal] = useState(false);
  const [render, setRender] = useState(false);

  const onFinish = async (values) => {
    const payload = {
      firstName: values.firstName || data?.firstName,
      lastName: values.lastName || data?.lastName,
      earnedPoints: data?.earnedPoints,
      billingAddress: {
        firstName: values.billingFirstName || data?.billingAddress?.firstName,
        lastName: values.billingLastName || data?.billingAddress?.lastName,
        streetAddress:
          values?.streetAddress || data?.billingAddress?.streetAddress,
        suiteNumber:
          values?.billingAddress?.suiteNumber ||
          data?.billingAddress?.suiteNumber,
        zipCode: values?.zipCode || data?.billingAddress?.zipCode,
        state: values?.state || data?.billingAddress?.state,
        city: values?.city || data?.billingAddress?.city,
      },
    };
    setInProgress(true);
    form.validateFields();
    const res = await updateCustomer(id, payload);
    if (res) {
      setInProgress(false);
      message.success("Customer details updated successfully");
      setRender(!render);
    }
  };

  useEffect(() => {
    setLoader(true);
    const fetchData = async () => {
      try {
        const res = await getCustomersDetils(id);
        const customerObj = {
          firstName: res?.firstName,
          lastName: res?.lastName,
          email: res?.email,
          phoneNumber: res?.phoneNumber,
          billingFirstName: res?.billingAddress?.firstName,
          billingLastName: res?.billingAddress?.lastName,
          city: res?.billingAddress?.city,
          state: res?.billingAddress?.state,
          streetAddress: res?.billingAddress?.streetAddress,
          suiteNumber: res?.billingAddress?.suiteNumber,
          zipCode: res?.billingAddress?.zipCode,
          earnedPoints: res?.earnedPoints,
          _id: res?._id,
        };
        setData(customerObj);
      } catch (error) {
      } finally {
        setLoader(false);
      }
    };

    fetchData();
  }, [id, render]);

  const onSuccess = () => {
    setEarnPointsModal(false);
    setRender(!render);
  };

  const showEarnPointsModal = () => {
    setEarnPointsModal(true);
  };

  const hideModal = () => {
    setEarnPointsModal(false);
  };

  const showForcePasswordModal = () => {
    setPasswordModal(true);
  };

  const hidePWModal = () => {
    setPasswordModal(false);
  };

  return (
    <>
      <div>
        <div className="grid gap-2 space-x-2 w-full pr-2">
          <div className="flex pt-3 pl-3 place-content-between">
            <Link to="/main/customers">
              <div className="flex items-center">
                <div className="w-4.4 m-auto grid justify-center h-auto py-1 rounded-lg bg-primaryPurple cursor-pointer">
                  <img src={Back} alt="Edit Icon" className="" />
                </div>
                <span className="text-lg font-bold text-black ml-1">
                  Customers
                </span>
              </div>
            </Link>
            {data && (
              <Space>
                <Button
                  title={`${data?.earnedPoints} Earned Points`}
                  color={colors.primaryPurple}
                  type="link"
                  className="!h-5"
                  onClick={showEarnPointsModal}
                  icon={<StarOutlined />}
                  danger
                />
                <Button
                  title={"Reset Password"}
                  color={colors.primaryPurple}
                  type="link"
                  className="w-16 !h-5"
                  onClick={showForcePasswordModal}
                  icon={<KeyOutlined />}
                  danger
                />
              </Space>
            )}
          </div>
          <Card className="rounded-2xl bg-white xl:relative">
            <div className="border-solid border-inputFieldGrey rounded-sm p-2 lg:px-5">
              {loader &&
                [1, 1, 1].map((m, i) => (
                  <div className="flex flex-row" key={i}>
                    <Skeleton
                      paragraph={{ rows: 2, width: [180, 220] }}
                      title={false}
                      loading={true}
                      className="pl-2 pr-2 pt-2"
                    ></Skeleton>
                    <Skeleton
                      paragraph={{ rows: 2, width: [180, 220] }}
                      title={false}
                      loading={true}
                      className="pl-2 pr-2 pt-2"
                    ></Skeleton>
                    <Skeleton
                      paragraph={{ rows: 2, width: [180, 220] }}
                      title={false}
                      loading={true}
                      className="pl-2 pr-2 pt-2"
                    ></Skeleton>
                    <Skeleton
                      paragraph={{ rows: 2, width: [180, 220] }}
                      title={false}
                      loading={true}
                      className="pl-2 pr-2 pt-2"
                    ></Skeleton>
                  </div>
                ))}
              {!loader && data && (
                <Form
                  className="w-full xl:content-start"
                  onFinish={onFinish}
                  form={form}
                  initialValues={data}
                  layout="vertical"
                >
                  <div>
                    <Typography.Title level={5}>Customer Info</Typography.Title>
                  </div>
                  <div className="w-full xl:grid xl:grid-cols-4 xl:gap-2 xl:content-start">
                    <Form.Item
                      name="firstName"
                      className=""
                      label="First Name"
                      rules={[
                        {
                          required: true,
                          message: "First name is required",
                        },
                      ]}
                    >
                      <InputField
                        className="hover:border-primaryBlue h-5.4"
                        defaultValue={data?.firstName}
                        placeholder="First Name"
                      />
                    </Form.Item>
                    <Form.Item
                      name="lastName"
                      className="w-full"
                      label="Last Name"
                      rules={[
                        {
                          required: true,
                          message: "Last name is required",
                        },
                      ]}
                    >
                      <InputField
                        className={"w-full hover:border-primaryPurple h-5.4"}
                        defaultValue={data?.lastName}
                        placeholder="Last Name"
                      />
                    </Form.Item>
                    <Form.Item
                      name="email"
                      className="w-full"
                      label="Email"
                      rules={[
                        {
                          required: true,
                          message: "Email is required",
                        },
                      ]}
                    >
                      <InputField
                        className={"w-full hover:border-primaryBlue h-5.4 "}
                        defaultValue={data?.email}
                        disabled
                      />
                    </Form.Item>

                    <Form.Item
                      name="phoneNumber"
                      className="w-full"
                      label="Phone No."
                      rules={[
                        {
                          required: true,
                          message: "Phone number is required",
                        },
                      ]}
                    >
                      <InputField
                        className={"w-full hover:border-primaryBlue h-5.4 "}
                        defaultValue={data?.phoneNumber}
                        disabled
                      />
                    </Form.Item>
                  </div>

                  <div>
                    <Typography.Title level={5}>
                      Billing Address
                    </Typography.Title>
                  </div>
                  <div className="w-full xl:grid xl:grid-cols-4 xl:gap-2 xl:content-start">
                    <Form.Item
                      name="billingFirstName"
                      className=""
                      label="First Name"
                    >
                      <InputField
                        className="hover:border-primaryBlue h-5.4"
                        defaultValue={data?.billingFirstName}
                        placeholder="First Name"
                      />
                    </Form.Item>
                    <Form.Item
                      name="billingLastName"
                      className="w-full"
                      label="Last Name"
                    >
                      <InputField
                        className={"w-full  hover:border-primaryBlue h-5.4 "}
                        defaultValue={data?.billingLastName}
                        placeholder="Last Name"
                      />
                    </Form.Item>
                    <Form.Item
                      name="zipCode"
                      className="w-full"
                      label="Zip Code"
                    >
                      <InputField
                        className={"w-full  hover:border-primaryBlue h-5.4 "}
                        defaultValue={data?.zipCode}
                        placeholder="Zip Code"
                      />
                    </Form.Item>
                    <Form.Item
                      name="streetAddress"
                      className="w-full"
                      label="Street Address"
                    >
                      <InputField
                        className={"w-full hover:border-primaryBlue h-5.4 "}
                        defaultValue={data?.streetAddress}
                        placeholder="Street Address"
                      />
                    </Form.Item>
                    <Form.Item name="city" className="w-full" label="City">
                      <InputField
                        className={"w-full hover:border-primaryBlue h-5.4 "}
                        defaultValue={data?.city}
                        placeholder="City"
                      />
                    </Form.Item>
                    <Form.Item
                      name="state"
                      className="w-full rounded-md"
                      label="State"
                    >
                      <Dropdown
                        defaultValue={data?.state}
                        placeholder={"State"}
                        data={usStates?.states}
                        // className={'h-5.4 flex justify-start items-center rounded-xl border-grey lg:w-31 xl:w-40'}
                      />
                    </Form.Item>
                  </div>
                  <Form.Item>
                    <div className="w-full flex justify-end">
                      <Button
                        color={colors.primaryPurple}
                        title="Save"
                        htmlType="submit"
                        loading={inProgress}
                        className="w-19"
                      />
                    </div>
                  </Form.Item>
                </Form>
              )}
              {earnPointsModal && (
                <EarnedPointsModal
                  data={data}
                  title="Earned Points"
                  onCancel={hideModal}
                  onOk={onSuccess}
                />
              )}
              {passwordModal && (
                <PasswordResetModal
                  data={data}
                  title="Reset Password"
                  onCancel={hidePWModal}
                  onOk={hidePWModal}
                />
              )}
            </div>
          </Card>
        </div>
      </div>
    </>
  );
};

export default Personalsettings;
